// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".occupancy-taxes__modal{height:500px}.occupancy-taxes__root{display:flex;height:100%}.occupancy-taxes__toolbar{border-right:1px solid #dee2e6;margin-right:5px;display:flex;flex-direction:column;padding-right:5px}.occupancy-taxes__grid{width:100%}#occupancy-taxes-info{justify-content:center;margin-top:.5rem}", ""]);
// Exports
module.exports = exports;
